import React from "react";
import {Tag} from "antd";
import {IconName} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslate} from "../../../../hooks/translate.hook";

interface HealthCenterIssueStatusProps {
    status: string;
    className?: string;
}

const statusConfig = (status: string): {color: string; icon: IconName} => {
    switch (status.toLowerCase()) {
        case "new":
            return {color: "error", icon: "exclamation-triangle"};
        case "in_progress":
        case "processing":
            return {color: "processing", icon: "sync"};
        case "resolved":
        case "closed":
            return {color: "success", icon: "check-circle"};
        default:
            return {color: "default", icon: "info-circle"};
    }
};

const formatStatus = (status: string): string => {
    const value = status.replaceAll("_", " ");

    return value.charAt(0).toUpperCase() + value.slice(1);
};

export const HealthCenterIssueStatus: React.FC<HealthCenterIssueStatusProps> = ({status, className}) => {
    const t = useTranslate();
    const config = statusConfig(status);

    return (
        <Tag
            className={["health-center-issues__status", className].filter(Boolean).join(" ")}
            color={config.color}
            icon={<FontAwesomeIcon icon={["fas", config.icon]} spin={config.icon === "sync"} />}
        >
            {t(`HEALTH-CENTER.ISSUES.STATUS.${status.toUpperCase()}`, {
                defaultValue: formatStatus(status),
            })}
        </Tag>
    );
};
